/**
 *
 * AddFile
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useUpload from 'containers/FileUpload/useUpload.js';
import { ProgressBar } from 'react-bootstrap';
import SelectFiles from '../SelectFiles/index.jsx';

const Wrapper = styled.div`
  button {
    padding: 0;
  }
`;

function AddFile(props) {
  const { value, onChange, type = 'any', ...rest } = props;
  const [progress, setProgress] = useState();
  const upload = useUpload();

  function handleUpload(item) {
    if (item.loading) {
      setProgress(item.progress);
    } else {
      window.setTimeout(setProgress, 1000);
      onChange(item.data);
    }
  }

  function handleChange(files) {
    if (files[0]) {
      const item = {
        file: files[0],
        progress: 0,
        loading: true,
      };
      upload(item, handleUpload);
    }
  }

  return (
    <Wrapper>
      {value && <div>{value.originalFileName}</div>}
      <SelectFiles type={type} {...rest} onChange={handleChange} />
      {progress !== undefined && <ProgressBar now={progress} label={`${progress}%`} />}
    </Wrapper>
  );
}

AddFile.propTypes = {
  value: PropTypes.object,
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default AddFile;
